import { connect } from 'react-redux';
import { LOGIN_INTRANET, LOGIN_EXTRANET } from 'store/auth/login/actionTypes';

import Login from './Login';

const mapStateToProps = (state) => ({
  loadingStep1: state.Login.loading,
  loadingStep2: state.Login.loading,

  me: state.Profile.me,
  loginError: state.Login.error,
});

const mapDispatchToProps = (dispatch) => ({
  actionLoginIntranet: (payload) => dispatch({
    type: LOGIN_INTRANET,
    payload,
  }),

  actionLoginExtranet: (payload) => dispatch({
    type: LOGIN_EXTRANET,
    payload,
  }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);
